module.exports = __webpack_public_path__ + "static/media/arrow-down.8649d993.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/arrow-down.svg
// module id = 1063
// module chunks = 0